import service from '@/utils/axios'

// 获取用户信息
export function genUesrInfo() {
  return new Promise((resolve, reject) => {
    service
      .get(`/system/user/getInfo`, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
// 通过身份证获取保单信息
export function getInfoByIdcard(code) {
  return new Promise((resolve, reject) => {
    service
      .get(`/business/userInsuranceList/getInfoByUserIdCard/${code}`, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 通过身份证获取保单信息
export function getTeamInfoByIdcard(code) {
  return new Promise((resolve, reject) => {
    service
      .get(`/business/userInsuranceList/individualUserGetInfoByUserIdCard/${code}`, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 通过手机号获取保单信息
export function getInfoByPhone(code) {
  return new Promise((resolve, reject) => {
    service
      .get(`/business/userInsuranceList/getInfoByPhone/${code}`, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 手机号登录
export function loginByPhone(data) {
  return new Promise((resolve, reject) => {
    service
      .post(`/auth/login`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 身份证登陆注册接口
export function loginByIdcard(data) {
  return new Promise((resolve, reject) => {
    service
      .post(`/auth/login`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 团体大户登录
export function loginByTeam(data) {
  return new Promise((resolve, reject) => {
    service
      .post(`/auth/login`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 提交确认信息
export function submitForm(data) {
  return new Promise((resolve, reject) => {
    service
      .put(`/business/userInsuranceList/submit`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 验证身份证正反面
// post
export function verifyIdCard(formData) {
  return service.post('/business/userInsuranceList/verifyIdCard', formData, {
    headers: {
      Authorization: sessionStorage.getItem('Authorization'),
      'Content-Type': 'multipart/form-data'
    },
    timeout: 60000
  })
}

// 验证银行卡
export function verifyBankCardFace(formData) {
  return service.post('/business/userInsuranceList/verifyBankCardFace', formData, {
    headers: {
      Authorization: sessionStorage.getItem('Authorization'),
      'Content-Type': 'multipart/form-data'
    },
    timeout: 60000
  })
}

// 验证签名
export function verifySignature(formData) {
  return service.post('/business/userInsuranceList/verifySignature', formData, {
    headers: {
      Authorization: sessionStorage.getItem('Authorization'),
      'Content-Type': 'multipart/form-data'
    },
    timeout: 60000
  })
}

// 验证人脸
export function verifyFacePhoto(formData) {
  return service.post('/business/userInsuranceList/verifyFacePhoto', formData, {
    headers: {
      Authorization: sessionStorage.getItem('Authorization'),
      'Content-Type': 'multipart/form-data'
    },
    timeout: 60000
  })
}

// 获取保单文件
export function getPolicyFile(userId) {
  return new Promise((resolve, reject) => {
    service
      .post(`/business/userInsuranceList/exportWord/${userId}`, {
        headers: {
          Authorization: sessionStorage.getItem('Authorization'),
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 个体投保提交表单

export function submitTeamForm(data) {
  return new Promise((resolve, reject) => {
    service
      .put(`/business/userInsuranceList/individualUserSubmit`, data, {
        headers: {
          Authorization: sessionStorage.getItem('Authorization'),
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 获取当前批次
export function getBatch() {
  return new Promise((resolve, reject) => {
    service
      .get(`/business/insuranceBatch/getCurrentBatch`, {
        headers: {
          Authorization: sessionStorage.getItem('Authorization'),
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 获取公示人员，query传参（支持分页）
export function getPublicityList(batchId, villageId, pageNum, pageSize) {
  return new Promise((resolve, reject) => {
    service
      .get(`/business/insuranceVillagePhoto/getVillagePhotoList?batchId=${batchId}&villageId=${villageId}&pageNum=${pageNum || ''}&pageSize=${pageSize || ''}`, {
        headers: {
          Authorization: sessionStorage.getItem('Authorization'),
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 根据批次查询村落
export function getVillage(batchId) {
  return new Promise((resolve, reject) => {
    service
      .get(`/business/insuranceVillage/villageVoList?batchId=${batchId}`, {
        headers: {
          Authorization: sessionStorage.getItem('Authorization'),
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
